import { API } from '../config/config';

/**
 * @typedef {Object} OrdersDashboardQuery
 * @property {string} group_by
 * @property {string} [status]
 * @property {string} [search]
 * @property {string} [date_from]
 * @property {string} [date_to]
 */

const buildQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      search.set(key, String(value));
    }
  });
  return search.toString();
};

const getErrorMessage = (error) => {
  const apiMessage = error?.response?.data?.message || error?.response?.data?.error;
  if (apiMessage) return String(apiMessage);
  if (error?.message) return String(error.message);
  return 'No se pudo cargar el dashboard de pedidos';
};

const OrdersDashboardService = {
  /**
   * @param {string} storeId
   * @param {OrdersDashboardQuery} query
   */
  async getDashboard(storeId, query) {
    if (!storeId) throw new Error('Store ID requerido');

    try {
      const queryString = buildQuery(query);
      const path = queryString
        ? `/stores/${storeId}/orders/dashboard?${queryString}`
        : `/stores/${storeId}/orders/dashboard`;

      const response = await API.get(path);
      return response?.data || { group_by: query?.group_by || 'client', groups: [] };
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  }
};

export default OrdersDashboardService;
